import React from 'react';
import { Hero } from './components/Hero';
import { ProductPreview } from './components/ProductPreview';
import { Problem } from './components/Problem';
import { Guides } from './components/Guides';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { Footer } from './components/Footer';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full bg-cream-50 text-ink selection:bg-rose-200" data-id="element-0" data-mp="31b8l22qjqjbb">
      <main data-id="element-1" data-mp="2wka0us2ft12s">
        <Hero data-id="element-2" data-mp="2wjgptewg3peu" />
        <ProductPreview data-id="element-3" data-mp="2wiyxgtcwlvc7" />
        <Problem data-id="element-4" data-mp="2wip6b2g4hi4x" />
        <Guides data-id="element-5" data-mp="2wi5n7ieqknpb" />
        <Bonuses data-id="element-6" data-mp="28ufm24yk52fw" />
        <Pricing data-id="element-7" data-mp="28tw972nrl48q" />
        <Guarantee data-id="element-8" data-mp="28te3zgj4jfoo" />
        <FAQ data-id="element-9" data-mp="28sl3gxardmez" />
        <CostOfInaction data-id="element-10" data-mp="28sbad0uf2z52" />
      </main>
      <Footer data-id="element-11" data-mp="23vuoyeelqyvo" />
    </div>;
}